<template>
  <div class="promo-code-modal" v-if="show">
    <div class="promo-code-modal-content">
      <h3>Promotion Code Discrepancy</h3>
      <p>
        There is a recurring promotion code on this member that doesn't match
        the promo chosen on the form. Which would you like to use?
      </p>
      <div class="button-container">
        <button class="btn btn-primary" @click="$emit('use-renewal-promo')">
          Keep renewal promotion code: {{ renewalPromoCode }}
        </button>
        <button class="btn btn-primary" @click="$emit('use-form-promo')">
          Keep form promotion code: {{ formPromoCode }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromoCodeDiscrepancyModal",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    renewalPromoCode: {
      type: String,
      required: true,
    },
    formPromoCode: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.promo-code-modal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.promo-code-modal-content {
  background-color: var(--bg-surface);
  color: var(--text-primary);
  padding: 30px;
  border-radius: 8px;
  width: 600px;
  max-width: 90%;
  box-shadow: 0 4px 15px var(--shadow-md);
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 25px;
}

.btn {
  padding: 10px 16px;
  white-space: normal;
  word-break: break-word;
  text-align: center;
}
</style>
